import React, { useState, useEffect } from 'react';
import { ADDON_LIST, ADDON_CATEGORIES, getAddonPrices, saveAddonPrices } from './addons';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#162A40',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#22C55E', red:'#EF4444', amber:'#F59E0B',
};

const inr = n => '₹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});
const inp = { width:'100%', padding:'8px 10px', background:'rgba(255,255,255,.05)', border:`1px solid rgba(30,58,95,1)`, borderRadius:6, color:'#F0F2FF', fontSize:12, boxSizing:'border-box', outline:'none', fontFamily:'Inter,sans-serif' };

export default function AddonsSelector({ addons, onChange, pax=1, isAdmin=false }) {
 const [prices, setPrices] = useState(getAddonPrices());
 const [editPrices, setEditPrices] = useState(false);
 const [filterCat, setFilterCat] = useState('All');
 const [tempPrices, setTempPrices] = useState({});

 useEffect(() => { setPrices(getAddonPrices()); }, []);

 const toggleAddon = (id) => {
 const current = addons[id] || { enabled:false, price:prices[id]||0, qty:1, note:'' };
 onChange({ ...addons, [id]: { ...current, enabled:!current.enabled, price:prices[id]||0 } });
 };

 const updateAddon = (id, field, value) => {
 onChange({ ...addons, [id]: { ...(addons[id]||{}), [field]:value } });
 };

 const handleSavePrices = () => {
 const newPrices = { ...prices, ...tempPrices };
 saveAddonPrices(newPrices);
 setPrices(newPrices);
 setTempPrices({});
 setEditPrices(false);
 // Update enabled addons with new prices
 const updated = { ...addons };
 Object.keys(updated).forEach(id => {
 if (updated[id]?.enabled && tempPrices[id]) {
 updated[id] = { ...updated[id], price: tempPrices[id] };
 }
 });
 onChange(updated);
 };

 const enabledAddons = ADDON_LIST.filter(a=>addons[a.id]?.enabled);
 const totalAddons = enabledAddons.reduce((s,a)=>{
 const ad = addons[a.id];
 const qty = parseInt(ad?.qty||1);
 const price = parseFloat(ad?.price||prices[a.id]||0);
 const isPerPax = a.unit==='per person';
 return s + (isPerPax ? price*pax*qty : price*qty);
 }, 0);

 const filtered = filterCat==='All' ? ADDON_LIST : ADDON_LIST.filter(a=>a.category===filterCat);

 return (
 <div>
 {/* Header */}
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text }}> Add-ons & Extras</div>
 <div style={{ display:'flex', gap:8, alignItems:'center' }}>
 {totalAddons>0 && <div style={{ fontSize:13, color:C.amber, fontWeight:700 }}>Total: {inr(totalAddons)}</div>}
 {isAdmin && (
 <button onClick={()=>{ setEditPrices(true); setTempPrices({}); }}
 style={{ padding:'5px 12px', background:'rgba(245,158,11,.15)', border:'1px solid rgba(245,158,11,.3)', borderRadius:6, color:C.amber, cursor:'pointer', fontSize:11, fontWeight:600 }}>
 Edit Prices
 </button>
 )}
 </div>
 </div>

 {/* Category filter */}
 <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:12 }}>
 {['All',...ADDON_CATEGORIES].map(cat=>(
 <button key={cat} onClick={()=>setFilterCat(cat)}
 style={{ padding:'4px 10px', borderRadius:20, border:`1px solid ${filterCat===cat?C.accent:C.border}`, background:filterCat===cat?`${C.accent}20`:'transparent', color:filterCat===cat?C.accent:C.text2, cursor:'pointer', fontSize:11, fontWeight:600 }}>
 {cat}
 </button>
 ))}
 </div>

 {/* Addon grid */}
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))', gap:8, marginBottom:16 }}>
 {filtered.map(addon=>{
 const ad = addons[addon.id] || {};
 const enabled = !!ad.enabled;
 const price = parseFloat(ad.price||prices[addon.id]||addon.defaultPrice||0);
 const qty = parseInt(ad.qty||1);
 const isPerPax = addon.unit==='per person';
 const subtotal = isPerPax ? price*pax*qty : price*qty;

 return (
 <div key={addon.id}
 style={{ background:enabled?`${C.accent}10`:C.surface, border:`2px solid ${enabled?C.accent:C.border}`, borderRadius:10, padding:12, cursor:'pointer', transition:'all .15s' }}>
 <div onClick={()=>toggleAddon(addon.id)} style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:enabled?10:0 }}>
 <div>
 <div style={{ fontSize:18, marginBottom:4 }}>{addon.icon}</div>
 <div style={{ fontSize:12, fontWeight:700, color:enabled?C.accent:C.text }}>{addon.name}</div>
 <div style={{ fontSize:10, color:C.text3 }}>{addon.unit}</div>
 </div>
 <div style={{ textAlign:'right' }}>
 <div style={{ fontSize:12, fontWeight:700, color:enabled?C.accent:C.text2 }}>{inr(price)}</div>
 <div style={{ width:20, height:20, borderRadius:'50%', background:enabled?C.accent:'rgba(255,255,255,.1)', display:'flex', alignItems:'center', justifyContent:'center', marginTop:4, marginLeft:'auto' }}>
 {enabled && <span style={{ color:'#fff', fontSize:12 }}></span>}
 </div>
 </div>
 </div>

 {enabled && (
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:6 }}>
 <div>
 <div style={{ fontSize:10, color:C.text3, marginBottom:2 }}>Price (₹)</div>
 <input type="number" value={ad.price||price} onChange={e=>updateAddon(addon.id,'price',e.target.value)}
 style={inp} onClick={e=>e.stopPropagation()} />
 </div>
 <div>
 <div style={{ fontSize:10, color:C.text3, marginBottom:2 }}>Qty</div>
 <input type="number" value={qty} min={1} onChange={e=>updateAddon(addon.id,'qty',parseInt(e.target.value)||1)}
 style={inp} onClick={e=>e.stopPropagation()} />
 </div>
 {subtotal>0 && (
 <div style={{ gridColumn:'span 2', fontSize:11, color:C.amber, fontWeight:600, textAlign:'right' }}>
 = {inr(subtotal)}{isPerPax?` (${pax} pax)`:''}
 </div>
 )}
 </div>
 )}
 </div>
 );
 })}
 </div>

 {/* Summary of selected */}
 {enabledAddons.length > 0 && (
 <div style={{ background:C.surface2, border:`1px solid ${C.border}`, borderRadius:10, padding:14 }}>
 <div style={{ fontWeight:700, fontSize:13, color:C.text, marginBottom:10 }}>Selected Add-ons ({enabledAddons.length})</div>
 {enabledAddons.map(addon=>{
 const ad = addons[addon.id];
 const qty = parseInt(ad?.qty||1);
 const price = parseFloat(ad?.price||prices[addon.id]||0);
 const isPerPax = addon.unit==='per person';
 const subtotal = isPerPax ? price*pax*qty : price*qty;
 return (
 <div key={addon.id} style={{ display:'flex', justifyContent:'space-between', padding:'4px 0', borderBottom:`1px solid ${C.border}`, fontSize:12 }}>
 <span style={{ color:C.text2 }}>{addon.icon} {addon.name} {qty>1?`× ${qty}`:''}</span>
 <span style={{ color:C.amber, fontWeight:600 }}>{inr(subtotal)}</span>
 </div>
 );
 })}
 <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0 0', fontSize:14, fontWeight:800 }}>
 <span style={{ color:C.text }}>Addons Total</span>
 <span style={{ color:C.amber }}>{inr(totalAddons)}</span>
 </div>
 </div>
 )}

 {/* Edit Prices Modal */}
 {editPrices && (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.8)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:16, padding:24, maxWidth:600, width:'100%', maxHeight:'80vh', overflow:'hidden', display:'flex', flexDirection:'column' }}>
 <div style={{ fontWeight:700, fontSize:16, color:C.text, marginBottom:16 }}> Edit Add-on Prices</div>
 <div style={{ flex:1, overflowY:'auto', display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:16 }}>
 {ADDON_LIST.map(addon=>(
 <div key={addon.id} style={{ display:'flex', alignItems:'center', gap:10, background:C.surface2, borderRadius:8, padding:10 }}>
 <span style={{ fontSize:16 }}>{addon.icon}</span>
 <div style={{ flex:1 }}>
 <div style={{ fontSize:11, color:C.text2, marginBottom:3 }}>{addon.name}</div>
 <input type="number"
 value={tempPrices[addon.id]??prices[addon.id]??addon.defaultPrice}
 onChange={e=>setTempPrices(p=>({...p,[addon.id]:parseFloat(e.target.value)||0}))}
 style={{ ...inp, padding:'5px 8px' }} />
 </div>
 <div style={{ fontSize:10, color:C.text3 }}>{addon.unit}</div>
 </div>
 ))}
 </div>
 <div style={{ display:'flex', gap:10 }}>
 <button onClick={()=>setEditPrices(false)} style={{ flex:1, padding:'10px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={handleSavePrices} style={{ flex:1, padding:'10px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700 }}>Save Prices</button>
 </div>
 </div>
 </div>
 )}
 </div>
 );
}
